import React from 'react'
import { isMobile } from 'react-device-detect'
import ArrowRightFromBracketIcon from 'client/utils/icons/arrow-right-from-bracket-icon'
import moment from 'moment'
import {
  DcButton,
  DcDateRangePicker,
  DcDiv,
  PixelDropDownMenu,
  PixelPopover,
} from 'pixel-base'
import FilterIcon from 'utils/icons/filter-icon'
import PlusIcon from 'utils/icons/plus-icon'
import UploadIcon from 'utils/icons/upload-icon'
import { IFilters } from 'client/../decl'
import Filter from '../SplitAndMerge/Filter'

interface OrdersActionsProps {
  dateFilter: {
    start_date: string | null
    end_date: string | null
  }
  setDateFilter: (filter: {
    start_date: string | null
    end_date: string | null
  }) => void
  filters: IFilters
  setFilters: (filters: IFilters) => void
  defaultFilters: {
    start_date: string
    end_date: string
    page: number
    page_size: number
  }
  setNewOrder: (value: boolean) => void
  setOrderId: (id: string | null) => void
  SetShowOrderDetailModal: (show: boolean) => void
  setShowModal: (show: boolean) => void
  setShowUpdateStatusModal: (show: boolean) => void
  exportReport: () => void
  isClosePopover: boolean
  setIsClosePopover: (value: boolean) => void
  setAppliedFiltersIds: (filters: IFilters) => void
}

const OrdersActions: React.FC<OrdersActionsProps> = ({
  dateFilter,
  setDateFilter,
  filters,
  setFilters,
  setNewOrder,
  setOrderId,
  SetShowOrderDetailModal,
  setShowModal,
  setShowUpdateStatusModal,
  exportReport,
  isClosePopover,
  setIsClosePopover,
  setAppliedFiltersIds,
}) => {
  const UpdateOptions = [
    {
      label: 'Bulk Status Update',
      disabled: false,
      clickHandler: () => {
        setShowUpdateStatusModal(true)
      },
    },
    {
      label: 'Create Orders Via Excel',
      disabled: false,
      clickHandler: () => {
        setShowModal(true)
      },
    },
  ]

  return (
    <DcDiv
      style={
        isMobile
          ? {
              display: 'inline-flex',
              flexDirection: 'column',
              gap: '5px',
              padding: '5px',
              width: '100%',
              justifyContent: 'flex-start',
              alignItems: 'flex-end',
            }
          : {
              display: 'inline-flex',
              flexDirection: 'row',
              gap: '5px',
              padding: '5px',
            }
      }
    >
      <DcDateRangePicker
        month={2}
        width={isMobile ? '100%' : 'auto'}
        size="sm"
        ranges={{
          start_date:
            dateFilter.start_date && moment(dateFilter.start_date).isValid()
              ? new Date(dateFilter.start_date)
              : '',
          end_date:
            dateFilter.end_date && moment(dateFilter.end_date).isValid()
              ? new Date(dateFilter.end_date)
              : '',
        }}
        onApply={() => {
          if (
            dateFilter.start_date &&
            dateFilter.end_date &&
            moment(dateFilter.start_date).isValid() &&
            moment(dateFilter.end_date).isValid()
          ) {
            const newFilters = {
              ...filters,
              start_date: dateFilter.start_date,
              end_date: dateFilter.end_date,
            }
            setFilters(newFilters)
            setAppliedFiltersIds(newFilters)
          }
        }}
        onChange={(e) => {
          setDateFilter({
            ...dateFilter,
            start_date: e.range1.startDate,
            end_date: e.range1.endDate,
          })
        }}
      />
      <DcButton
        width={isMobile ? '100%' : 'auto'}
        size="sm"
        variant="outline-success"
        onClick={() => {
          setNewOrder(true)
          setOrderId(null)
          SetShowOrderDetailModal(true)
        }}
        withIcon={true}
      >
        <PlusIcon size={14} />
        <span> Add New</span>
      </DcButton>

      <DcButton
        width={isMobile ? '100%' : 'auto'}
        size="sm"
        variant="outline-secondary"
        onClick={() => {
          exportReport()
        }}
        withIcon={true}
      >
        <ArrowRightFromBracketIcon size={16} />
        <span>Export</span>
      </DcButton>

      <PixelPopover
        width={isMobile ? '100%' : 'auto'}
        PopoverContent={
          <Filter
            setIsClosePopover={setIsClosePopover}
            filters={filters}
            setFilters={setFilters}
            setAppliedFiltersIds={setAppliedFiltersIds}
          />
        }
        popoverPlacement={'left'}
        hideOnClickOutside={false}
        closePopover={isClosePopover}
        overlayButton={
          <DcButton
            size="sm"
            width={isMobile ? '100%' : 'auto'}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '5px !important',
            }}
            variant="outline-secondary"
            withIcon={true}
          >
            <FilterIcon size={16} />
            <span>Filters</span>
          </DcButton>
        }
        styledPopover={{
          width: isMobile ? '60vw' : '355px',
          maxWidth: isMobile ? '60vw' : '355px',
          padding: '10px',
          position: 'relative !important',
          zIndex: 1050,
        }}
        onPopoverExit={() => {
          setIsClosePopover(false)
        }}
      />
      <DcDiv width={isMobile ? '100%' : '95px'}>
        <PixelDropDownMenu
          width={isMobile ? '100%' : 'auto'}
          variant="outline"
          size="sm"
          options={UpdateOptions}
          toggleText={
            <>
              <UploadIcon size={16} />
              &nbsp;Update
            </>
          }
        />
      </DcDiv>
    </DcDiv>
  )
}

export default OrdersActions
